import React from 'react';

export const Facebook = (props) => (
  <svg width="100%" height="100%" viewBox="0 0 13 23" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.26 7.01H8V5.1A1 1 0 019 4h3V0H7.67C3.74 0 3 3 3 4.86v2.15H0v4h3v11.5h5v-11.5h3.85l.41-4z"
      fillRule="evenodd"
    />
  </svg>
);

export default Facebook;
